// extracted by mini-css-extract-plugin
export default {"dialog":"modal_dialog__ZwrGw","open":"modal_open__-tv+X"};